import React, { Component } from 'react';
import { Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import rest from 'rest';

import { REST_API_URL, PERMISSION_CREATE, APP_PATH } from "../../Utils/Global";
import { arrayToCsv, downloadCsv } from "../../Utils/Utils";

import PermissionCheck from '../Permissions/PermissionCheck';

import Combobox from '../Helper/Combobox';
import ExportCSV from '../Helper/Grid/ExportCSV';
import Grid from '../Helper/Grid'
import GridFilter from '../Helper/GridFilter'

import Contrat from '../Entity/Contrat'

/**
* Class ContratList
* ContratList view component
**/
class ContratList extends Component {

  constructor(props) {
    super(props);
    this.state = {
      objectif: {}
    };
  }

  /**
  * render
  * Rendering component function : display the view
  **/
  render() {
    const objectClass = Contrat;

    // Filter list
    const filters = this.getFilters();

    // Rendering the view
		return (
      <div className="searchContainer">
        <h2>Gérer mes occupations</h2>
        <GridFilter title="Filtrer les occupations" objectClass={objectClass.getClassName()} filters={filters} parent={this} formattedFilters={true} />

        <PermissionCheck component={objectClass.getClassName()} permission={PERMISSION_CREATE}>
          <div className="addManyToOneFromSearch">
            <Combobox url={REST_API_URL + "objectifs/?estContrat=true"} optionValueKey="idObjectif" optionLabelKey="libelle"
              onChange={this.onObjectifSelect.bind(this)} placeholder="Choisir un objectif" />

            <p className="gridBottomToolbar">
              <Link to={APP_PATH + "/objectifs/" + ((this.state.objectif === undefined) ? undefined : this.state.objectif.idObjectif) + "/contrats/add"}>
                <Button disabled={this.state.objectif === undefined || this.state.objectif.idObjectif === undefined} bsStyle="success" className="gridAddObjectBtn">Ajouter une occupation</Button>
              </Link>
            </p>
          </div>
        </PermissionCheck>

        <Grid title="Occupations" ref={"gridContrat"} path="contrats" objectPath="contrats" customFieldsUrl="fields-search" ignoreAdd={true} objectClass={objectClass}
          height="400px" hidden={false} condensed={true} />
        <ExportCSV parent={this} gridRef="Contrat" customFn={this.exportContrats.bind(this)} />
      </div>
		);
	}

  /**
  * applyFilter
  * Filters the grid
  **/
  applyFilter(fieldName, value) {
    const grid = this.refs.gridContrat;
    grid.applyFilter(fieldName, value);
  }

  applyNumFilter(fieldName, values) {
    const grid = this.refs.gridContrat;
    grid.applyNumFilter(fieldName, values);
  }

  /**
  * applyNumericFilter
  * Filters the grid
  **/
  applyNumericFilter(fieldName, values) {
    const grid = this.refs.gridContrat;
    grid.applyNumericFilter(fieldName, values);
  }

  /**
  * applyDateIntervalFilter
  * Filters the grid
  **/
  applyDateIntervalFilter(fieldName, values) {
    const grid = this.refs.gridContrat;
    grid.applyDateIntervalFilter(fieldName, values);
  }

  /**
  * applyArrayFilter
  * Filters the grid
  **/
  applyArrayFilter(fieldName, value) {
    const grid = this.refs.gridContrat;
    grid.applyArrayFilter(fieldName, value);
  }

  /**
  * applyObjectFilter
  * Filters the grid
  **/
  applyObjectFilter(fieldName, value, idField) {
    const grid = this.refs.gridContrat;
    grid.applyObjectFilter(fieldName, value, idField);
  }

  /**
  * applyDateFilter
  * Filters the grid
  **/
  applyDateFilter(filterField, dateValue, comparatorValue) {
    const grid = this.refs.gridContrat;
    grid.applyDateFilter(filterField, dateValue, comparatorValue);
  }

  /**
  * clearFilters
  * Clear the filters
  **/
  clearFilters() {
    const grid = this.refs.gridContrat;
    grid.clearFilters();
  }

  /**
  * onObjectifSelect
  * Handle Objectif selection
  **/
  onObjectifSelect(objectif) {
    this.setState({
      objectif: objectif
    });
  }

  /**
  * getFilters
  * Returns the filters
  **/
  getFilters() {
    return [{
      title: "N°",
      type: "combo",
      name: "idContrat",
      optionValueKey: "idContrat",
      optionLabelKey: "numero",
      searchable: true,
      url: REST_API_URL + "/contrats/numeros",
      rowIdx: 0
    },{
      title: "Client",
      type: "combo",
      name: "idClient",
      optionValueKey: "idClient",
      optionLabelKey: "libelle",
      searchable: true,
      url: REST_API_URL + "/clients/",
      rowIdx: 0
    },{
      title: "Etat",
      type: "combo",
      name: "idEtatContrat",
      optionValueKey: "etatId",
      optionLabelKey: "etatLibelle",
      url: REST_API_URL + "/etatcontrats/",
      rowIdx: 0
    },{
      title: "Site",
      type: "combo",
      isObject: true,
      name: "site.siteId",
      optionValueKey: "siteId",
      optionLabelKey: "siteNomCourt",
      url: REST_API_URL + "/sites/",
      rowIdx: 0
    },
    // {
    //   type: "map",
    //   layer: "contrat",
    //   name: "idContrat",
    //   rowIdx: 0
    // },
    {
      title: "Date de début",
      type: "dateinterval",
      name: "dateDebut",
      rowIdx: 1
    },{
      title: "Date de fin",
      type: "dateinterval",
      name: "dateFin",
      rowIdx: 1
    },{
      title: "Duree",
      type: "num",
      name: "duree",
      rowIdx: 1
    },{
      title: "Unité de durée",
      type: "combo",
      isObject: true,
      name: "uniteTempsDuree.idUniteTemps",
      optionValueKey: "idUniteTemps",
      optionLabelKey: "libelle",
      url: REST_API_URL + "/unitetemps/",
      rowIdx: 1
    },{
      title: "Tacite reconduction",
      type: "combo",
      name: "taciteReconduction",
      dataSource: {collection: [{id: "true", name: "Oui"}, {id: "false", name: "Non"}]},
      rowIdx: 2
    },{
      title: "Fréquence de facturation",
      type: "combo",
      isObject: true,
      name: "frequenceFacturation.idFrequenceFacturation",
      optionValueKey: "idFrequenceFacturation",
      optionLabelKey: "libelle",
      url: REST_API_URL + "frequencefacturations/",
      rowIdx: 2
    },{
      title: "Objectif",
      type: "combo",
      name: "idObjectif",
      optionValueKey: "idObjectif",
      optionLabelKey: "libelle",
      url: REST_API_URL + "/objectifs/?estContrat=true",
      rowIdx: 2
    },{
      title: "Thématique de l'objectif",
      type: "combo",
      multi: true,
      isArray: true,
      name: "objectifThematiques",
      optionValueKey: "idThematique",
      optionLabelKey: "libelle",
      url: REST_API_URL + "/thematiques/",
      rowIdx: 2
    },{
      // title: "Redevance théorique annuelle",
      title: "Redevance",
      type: "numeric",
      name: "redevanceTheoriqueAnnuelle",
      rowIdx: 3
    },{
      title: "Numéro de parcelle",
      type: "combo",
      name: "idParcelleGestionPag",
      optionValueKey: "gid",
      optionLabelKey: "idu",
      searchable: true,
      url: REST_API_URL + "/parcellegestionpag/",
      rowIdx: 3
    },{
      title: "Activité portuaire",
      type: "combo",
      name: "activitePortuaire",
      dataSource: {collection: [{id: "true", name: "Oui"}, {id: "false", name: "Non"}]},
      rowIdx: 3
    },{
      title: "Secteur d'activité",
      type: "combo",
      name: "idSecteurActivite",
      optionValueKey: "idSecteurActivite",
      optionLabelKey: "libelle",
      url: REST_API_URL + "/secteuractivites/",
      rowIdx: 3
    }];
  }

  /**
  * exportContrats
  * Export Contrats as csv
  **/
  async exportContrats() {
    const grid = this.refs.gridContrat;
    const table = grid.refs.tableContrat;
    const data = table.getTableDataIgnorePaging();
    let idContrats = "";

    if(data.length !== grid.state.objects.length) {
      const arrIds = data.map(contrat => contrat.idContrat);
      idContrats = arrIds.join(",");
    }

    const contrats = await this.getContrats(idContrats);
    let arrData = [this.getCsvColumns()];

    contrats.forEach(({contrat, elementContrats}) => {
      elementContrats.forEach(elementContrat => {
        console.log(elementContrat);
        //elementContrat.redevanceTheorique="1002.45454";
        //elementContrat.redevanceTheorique=parseFloat(elementContrat.redevanceTheorique).toFixed(2).toString();
        let elementContratData = [
          contrat.numero,
          this.getSubObjectProperty(["site", "siteNomCourt"], contrat),
          this.getSubObjectProperty(["client", "libelle"], contrat),
          contrat.dateDebut,
          contrat.dateFin,
          contrat.duree,
          this.getSubObjectProperty(["uniteTempsDuree", "libelle"], contrat),
          grid.booleanFormatter.call(grid, contrat.taciteReconduction, null, null, false),
          this.getSubObjectProperty(["tarification", "tarif", "libelle"], elementContrat),
          this.getSubObjectProperty(["tarification", "tarif", "valeur"], elementContrat),

          this.getSubObjectProperty(["tarification", "remise1"], elementContrat),
          this.getSubObjectProperty(["tarification", "remise2"], elementContrat),

          grid.booleanFormatter.call(grid, this.getSubObjectProperty(["tarification", "estFacture"], elementContrat), null, null, false),
          // contrat.facturationActuelle,

          this.getSubObjectProperty(["tarification", "surface"], elementContrat),
          this.getSubObjectProperty(["tarification", "tarif", "unite", "titre"], elementContrat),
          this.getSubObjectProperty(["tarification", "redevanceTheorique"], elementContrat),
          this.getSubObjectProperty(["frequenceFacturation", "libelle"], contrat),

          // - Etat du contrat
          this.getSubObjectProperty(["etatContrat", "etatLibelle"], contrat),
          // - activité portuaire
          grid.booleanFormatter.call(grid, contrat.activitePortuaire, null, null, false),
          // - secteur activité
          this.getSubObjectProperty(["secteurActivite", "libelle"], contrat),
          // - code NAF/APE
          contrat.codeNaf,
          // - nombre emploi
          contrat.nombreEmploi,
          // - montant investi
          contrat.montantInvesti,
          // - occupation bâtiment
          grid.booleanFormatter.call(grid, contrat.occupationBati, null, null, false),
          // - dimension bâtiment
          contrat.dimensionBati,

          contrat.objet,
          contrat.observationAdminJuridique,
          contrat.observationFinanciere,
          contrat.observationOperationnel,
          elementContrat.parcelle,
          elementContrat.numeroLot,
          elementContrat.numeroBati,
          elementContrat.numeroCellule,
        ];

        elementContratData = elementContratData.map(value => {
          if(typeof value === "string") value = value.replace(/\n/g, " ");
          if(typeof value === "string") value = value.replace(/;/g, ",");
          return value;
        })

        arrData.push(elementContratData);
      });
    });

    const csv = arrayToCsv(arrData);
    downloadCsv(csv, "Contrats");
  }

  /**
  * getSubObjectProperty
  * Returns the sub property value
  **/
  getSubObjectProperty(arrProperties, object) {
    if(object === undefined) object = this.state.object;
    if(arrProperties.length === 0) return object;

    const property = arrProperties.shift();
    switch(arrProperties.length) {
      case 0:
        return (object !== undefined && object[property] !== undefined && object[property] !== null) ? object[property] : "";
      default:
        object = object[property];
        return object ? this.getSubObjectProperty(arrProperties, object) : "";
    }
  }

  /**
  * getContrats
  * Get Contrats data to export
  **/
  getContrats(idContrats) {
    return new Promise((resolve, reject) => {
      rest({method: 'GET', path: `${REST_API_URL}/contrats/export?contrats=${idContrats}`}).then(response => {
        const objects = JSON.parse(response.entity);
        resolve(objects);
      });
    });
  }

  /**
  * getCsvColumns
  * Get columns titles to export
  **/
  getCsvColumns() {
    return [
      "N° Contrat",
      "Site",
      "Occupant",
      "Date d'effet",
      "Date de fin",
      "Durée",
      "Unité durée",
      "Tacite reconduction",
      "N° Tarif",
      "Tarif",
      "Remise 1",
      "Remise 2",
      "Facturé",
      "Dimension",
      "Unité",
      "Redevance",
      // "Recette",
      "Prélèvement",
      "Etat du contrat",
      "Activité portuaire",
      "Secteur activité",
      "Code NAF/APE",
      "Nombre emploi",
      "Montant investi",
      "Occupation bâtiment",
      "Dimension bâtiment",
      "Objet",
      "Observation administrative",
      "Observation financière",
      "Observation opérationnelle",
      "Parcelle",
      "Lot",
      "Bâtiment",
      "Cellule",
    ]
  }

}
export default ContratList;



// WEBPACK FOOTER //
// ./src/views/Search/ContratList.js